import type { MetaFunction } from "react-router";
import Privacy from "@/pages/privacy";

export const meta: MetaFunction = () => {
  return [
    { title: "Privacy Policy | Arcitext" },
    {
      name: "description",
      content: "Learn how Arcitext protects your privacy and handles your data.",
    },
    {
      tagName: "link",
      rel: "canonical",
      href: "https://www.arcitext.com/privacy",
    },
  ];
};

// This route uses static pre-rendering
export default function PrivacyRoute() {
  return <Privacy />;
}
